// removed by extract-text-webpack-plugin
module.exports = {"container":"listAudio-module_container_GGAn2","itemDescription":"listAudio-module_itemDescription_2Menn","flexColumn":"listAudio-module_flexColumn_3pmRv","spaceBetween":"listAudio-module_spaceBetween_10AmB","meta":"listAudio-module_meta_2fW6R listAudio-module_spaceBetween_10AmB","itemSummary":"listAudio-module_itemSummary_14l41","thumbnail":"listAudio-module_thumbnail_1KJCs"};


//////////////////
// WEBPACK FOOTER
// ./client/components/itemCard/listAudio.module.css
// module id = 294
// module chunks = 1 2 3